import React from 'react';
import { Grid, Button, Paper } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux';
import { ExitButton } from '../../../utils/etc';
import _ from 'lodash';
import { editFlight } from '../../../store/flights'
import { loadDepartures } from "../../../store/dcs";

const formatFlightDate = (date) => {
  // NOTE // input: 2021-08-17, output: 17AUG2021
  let day = date.slice(8, 10)
  let month = date.slice(5, 7)
  let year = date.slice(0, 4)
  let monthsArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  month = monthsArr[Number(month) - 1]
  return `${day + month + year}`
}

// TODO // look into combining container and item props for Grid
const CloseFlightModal = (props) => {
  const dispatch = useDispatch()
  const closeFlightStatus = useSelector(state => state.entities.flights.editReqStatus)
  const modalClasses = props.modalClasses
  const flight = props.flight
  const date = props.date
  const closeModal = props.closeModal

  const changeFlightStatus = () => {
    let editData = {date: formatFlightDate(date), origin: flight.Origin, activity: flight.status === 'open' ? 'close' : 'open'}
    let payload = {editData: editData, flightNumber: flight.FlightNumber, type: 'closeFlight'}
    dispatch(editFlight(payload))
  }

  if (closeFlightStatus !== 'Default' && closeFlightStatus !== null) {
    return (
      <Grid container justify="center" alignContent="center" style={{marginTop: '25%'}}>
        <Paper className={modalClasses.closeFlightPaper}>
          <Grid container item xs={12} justifyContent="center">
            <h3>{closeFlightStatus}</h3>
          </Grid>
          <Grid container item xs={12} justifyContent="center">
            <Button variant="contained" onClick={() => {dispatch(loadDepartures(formatFlightDate(date))); closeModal()}} style={{backgroundColor: '#eb494e', fontWeight: 'bold', marginBottom: '8px'}}>Close</Button>
          </Grid>
        </Paper>
      </Grid>
    )
  }
  else {
    return (
      <Grid container justifyContent="center" alignContent="center" style={{marginTop: '10%'}}>
        <Paper className={modalClasses.closeFlightPaper}>
          <Grid id="modal-header" container item xs={12} justifyContent="center" className={modalClasses.modalHeader}>
            <Grid item xs={2} lg={3}></Grid>
            <Grid container justifyContent="center" item xs={8} lg={6}>
              <h5 style={{margin: "0px", paddingTop: "12px"}}>
                {flight.FlightNumber + " Close Flight"}
              </h5>
            </Grid>
            <Grid item xs={1} lg={2}></Grid>
            <Grid container alignContent="flex-start" justifyContent="flex-end" style={{paddingRight: '8px'}} item xs={1}>
              <ExitButton exit={closeModal} />
            </Grid>
          </Grid>
          <Grid container justifyContent="center">
            <Grid container justifyContent="center" item xs={12}>
              <h4>
                Are you sure you want to {flight.status === 'open' ? `close ${flight.FlightNumber}` : `open ${flight.FlightNumber}`}
              </h4>
            </Grid>
            <Grid container justifyContent="center" item xs={12} style={{marginBottom: '8px'}}>
              <Button variant="contained" onClick={() => {changeFlightStatus()}} style={{backgroundColor: '#03fc66', marginRight: '8px'}}>Yes</Button>
              <Button variant="contained" onClick={() => {closeModal(false)}} style={{backgroundColor: '#eb494e'}}>No</Button>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    )
  }
}

export default CloseFlightModal